import { Sector, SectorValues } from '@/domain/impact/impact.entity';
import {
  ImpactCo2Answer,
  RecyclableWasteType,
  Source,
  SourceValues,
  ValuesRecyclableWaste,
} from '@/domain/impact-co2/entities/question.entity';
import { RecyclableWasteTypeValues } from '@/domain/impact-co2/entities/question.entity';
import { validateValueInType } from '@/domain/utils/validate-value-in-type';

import { QuestionRecyclableWasteDto } from './dto.type';

export class QuestionRecyclableWasteMapper {
  static dtoToEntity(
    dto: QuestionRecyclableWasteDto,
  ): ImpactCo2Answer<ValuesRecyclableWaste> {
    return {
      id: dto.id,
      userId: dto.userId,
      sector: validateValueInType<Sector>(dto.sector, SectorValues),
      category: 'RECYCLABLE_WASTE',
      isExternal: dto.isExternal,
      source: validateValueInType<Source>(dto.source || '', SourceValues),
      values: {
        recyclableWasteType: validateValueInType<RecyclableWasteType>(
          dto.recyclableWasteType,
          RecyclableWasteTypeValues,
        ),
        recyclableWasteQuantity: parseFloat(
          dto.recyclableWasteQuantity.toString(),
        ),
        label: dto.label || '',
        score: dto.score || 0,
        tags:
          dto?.tags?.values?.map((tag) => ({ id: tag.id, name: tag.name })) ||
          [],
      },
    };
  }

  static entityToDto(
    answer: ImpactCo2Answer<ValuesRecyclableWaste>,
    projectId: number,
  ): Omit<
    QuestionRecyclableWasteDto,
    'id' | 'userId' | 'score' | 'isExternal'
  > {
    return {
      projectId: projectId,
      sector: answer.sector,
      recyclableWasteType: answer.values.recyclableWasteType,
      recyclableWasteQuantity: answer.values.recyclableWasteQuantity,
      label: answer.values.label || '',
      source: answer.source !== '' ? answer.source : undefined,
      tags: { values: answer.values.tags },
    };
  }
}
